import * as React from "react";
const SvgChip = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 108q42-148 92 0", style: {
  stroke: "#f03",
  fill: "none",
  strokeWidth: 3
} }));
export default SvgChip;
